import { Explore } from "@mui/icons-material";
import {
  Box,
  styled,
  Drawer,
  Button,
  IconButton,
  Typography,
} from "@mui/material";

export const MainDrawer = styled(Drawer)(() => ({
  width: "350px",
  flexShrink: 0,
  ".MuiDrawer-paper": {
    width: "350px",
    color: "white",
    background: "#212121",
    visibility: "visible",
    overflow: "auto",
    display: "flex",
    minHeight: "100vh",
    flexDirection: "column",
    "&::-webkit-scrollbar-track": {
      "-webkit-box-shadow": "inset 0 0 4px rgba(0,0,0,0.3)",
      borderRadius: "10px",
      backgroundColor: "#212121",
    },
    "&::-webkit-scrollbar": {
      width: "3px",
      backgroundColor: "#212121",
      paddingRight: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      "-webkit-box-shadow": "inset 0 0 4px rgba(0,0,0,.3)",
      backgroundColor: "#424242",
    },
  },
}));

export const DrawerHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: "0 20px",
  marginBottom: "8px",
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
  color: "#fff",
  background: "#1A1C1D",
  minHeight: "64px",
  position: "fixed",
  width: "350px",
  zIndex: 9,
}));

export const TitleText = styled(Typography)(() => ({
  width: "100%",
}));

export const ActionButton = styled(IconButton)(() => ({
  color: "#fff",
}));

export const MainSideContent = styled(Box)(() => ({
  flex: "1",
  width: "350px",
  padding: "65px 0",
  background: "#212121",
}));

export const SliderContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "flex-start",
}));

export const RadiusWarning = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-around",
  alignItems: "center",
  color: "#E5E5E5",
  padding: "10px",
}));

export const ExploreIcon = styled(Explore)(() => ({
  margin: "0 7px",
  fontSize: "2.5rem",
}));

export const ButtonContainer = styled(Box)(() => ({
  width: "100%",
  padding: "10px 0",
  display: "flex",
  justifyContent: "center",
}));

export const RemoveRouteButton = styled(Button)(() => ({
  display: "flex",
  justifyContent: "center",
  backgroundColor: "#000",
  color: "#fff",
  fontSize: "1.2rem",
  fontWeight: "bold",
  padding: "15px 0",
  width: "86%",
  borderRadius: "3px",
  border: "#fff solid 1px",
  cursor: "pointer",

  transition: "all .3s linear",
  "&:hover": {
    backgroundColor: "#555",
    border: "#555 solid 1px",
  },
  "& svg": {
    padding: "0 20px",
  },
}));

export const OpenListButton = styled(Button)(() => ({
  display: "flex",
  justifyContent: "center",
  fontSize: "1rem",
  fontWeight: "bold",
  padding: "15px 0",
  width: "86%",
  borderRadius: "3px",
  border: "none",
  cursor: "pointer",
  backgroundColor: "#fff",
  color: "#000",

  transition: "all .3s linear",
  "&:hover": {
    backgroundColor: "#555",
    color: "#fff",
  },
  "& svg": {
    padding: "0 20px",
  },
}));

export const SideFooter = styled(Box)(() => ({
  left: 0,
  width: "350px",
  bottom: "10px",
  padding: "10px 0px",
  textAlign: "center",
  background: "#212121",
  color: "#fff",
}));
